/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/allas/components/standalone/InputCaption/theme';

export const InputCaptionTheme = theme;
